import PriceListsAndPromotionsToEventTransformer from './PriceListsAndPromotionsToEventTransformer'

class PriceListsAndPromotionsToEventsTransformer {
  transform (masterPriceLists, relatedPriceLists, promotions) {
    let eventTransformer = new PriceListsAndPromotionsToEventTransformer()
    let events = []

    for (let i = 0; i < masterPriceLists.length; i++) {
      let master = masterPriceLists[i]

      //if (master.speaApiVersion)
      {

        let masterRelated = relatedPriceLists[i] ? relatedPriceLists[i] : []
        let masterPromotions = promotions[i] ? promotions[i] : []
        let event = eventTransformer.transform(master, masterRelated, masterPromotions)
        event.speaApiVersion = master.speaApiVersion
        events.push(event)
      }
    }
    return events
  }
}
export default PriceListsAndPromotionsToEventsTransformer



// WEBPACK FOOTER //
// ./src/transformers/PriceListsAndPromotionsToEventsTransformer.js